import React from 'react';
import { useSelector } from 'react-redux';

import { EditableCardType } from '@app/redux/scrubbedAddress';
import { selectUserInfo } from '@app/redux/userInfo';

import { PlanAndAddonsTab } from './PlanAndAddonsTab';
import { CommonProfileProps, ProfileTab } from '../types';

const ResidentialAccountInfoTab = React.lazy(() => import('./AccountInfoTab/ResidentialAccountInfoTab'));

const ResidentialContactInfoTab = React.lazy(() => import('./ContactInfoTab/ResidentialContactInfoTab'));

const SmbAccountInfoTab = React.lazy(() => import('./AccountInfoTab/SmbAccountInfoTab'));

const SmbBusinessInfoTab = React.lazy(() => import('./ContactInfoTab/SmbBusinessInfoTab'));

interface TabProps extends CommonProfileProps {
  currentTab: ProfileTab;
  editingCard: EditableCardType;
  closeAfterReload: boolean;
  navigateToChangePlan: () => void;
  navigateToScheduleInstallation: () => void;
}

const CurrentTab = (props: TabProps) => {
  const { loading } = useSelector(selectUserInfo);

  switch (props.currentTab) {
    case ProfileTab.ResidentialAccount:
      return <ResidentialAccountInfoTab {...props} id={props.currentTab} loading={loading} />;
    case ProfileTab.SMBAccount:
      return <SmbAccountInfoTab {...props} id={props.currentTab} />;
    case ProfileTab.ResidentialContact:
      return <ResidentialContactInfoTab {...props} id={props.currentTab} />;
    case ProfileTab.SMBBusiness:
      return <SmbBusinessInfoTab {...props} id={props.currentTab} loading={loading} />;
    case ProfileTab.InternetPlan:
      return (
        <PlanAndAddonsTab
          navigateToChangePlan={props.navigateToChangePlan}
          navigateToScheduleInstallation={props.navigateToScheduleInstallation}
        />
      );
    default:
      return null;
  }
};

export default CurrentTab;
